import { render, staticRenderFns } from "./PaginationFilterBuilder.vue?vue&type=template&id=08dedeca&scoped=true"
import script from "./PaginationFilterBuilder.vue?vue&type=script&lang=js"
export * from "./PaginationFilterBuilder.vue?vue&type=script&lang=js"
import style0 from "./PaginationFilterBuilder.vue?vue&type=style&index=0&id=08dedeca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dedeca",
  null
  
)

export default component.exports